import Length from "./Length";
import Rectangle from "./Rectangle";
import Area from "./Area";
import AbstractShape from "./AbstractShape";

export default class IsoscelesTriangle extends AbstractShape {
	static NAME = "isosceles-triangle";

	constructor( base, height ) {
		super();

		this.base = base;
		this.height = height;
	}

	get_name() {
		return IsoscelesTriangle.NAME;
	}

	get_enclosing_rectangle() {
		return new Rectangle( this.base, this.height );
	}

	get_area() {
		return new Area( this.base.in_mm() * this.height.in_mm() / 2 );
	}

	get_circumference() //a^2 + b^2 = c^2
	//c = sqrt( a^2 + b^2 )
	{
		const a = this.base.in_mm() / 2;
		const b = this.height.in_mm();
		const c = Math.sqrt( Math.pow( a, 2 ) + Math.pow( b, 2 ) );
		return new Length( this.base.in_mm() + c * 2 );
	}

	get_base() {
		return this.base;
	}

	get_height() {
		return this.height;
	}

	get_maximum_dimensions( maximum_rectangle ) //Both the base and the height can never be bigger than the longest length.
	{
		const longest_side = maximum_rectangle.get_longest_side();
		return {
			base: longest_side,
			height: longest_side
		};
	}

	get_dimension_keys() {
		return [ "base", "height" ];
	}

	get_modifier_keys() {
		return [];
	}

	serialize_primitives() {
		return {
			base: this.base.in_mm(),
			height: this.height.in_mm()
		};
	}

	static deserialize_primitives( primitives ) {
		return new IsoscelesTriangle( new Length( primitives.base ), new Length( primitives.height ) );
	}

}
